// @flow

import React from 'react';

import { Typography, Link } from '@material-ui/core/';

import Image from '../image';
import Assets from '../../assets';

import './style.css';

function AppLogo() {
    return (
        <Typography component="div" className="align-left">
            <Link color="inherit" href="/">
                <Image
                    src={Assets.Images.Logo.Path}
                    alt={Assets.Images.Logo.Alt}
                    className="app-logo"
                />
            </Link>
        </Typography>
    );
}

export default AppLogo;
